"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inRange = exports.getTileUnsafe = exports.getTileAtMouse = exports.getTile = exports.setImageTo = exports.tryJumpToTarget = exports.updateAll = exports.setVisible = exports.kill = exports.killAll = exports.create = exports.get = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var imports_1 = require("@lib/imports");
var common_1 = require("@main/common");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var voyageCameraStarmap_sidecar_1 = require("@voyage/camera/voyageCameraStarmap-sidecar");
var voyageGameMode_game_hyperspace_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_game_hyperspace-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
var voyageStarmapGenerator_sidecar_1 = require("./voyageStarmapGenerator-sidecar");
var voyageStarmapTiles_sidecar_1 = require("./voyageStarmapTiles-sidecar");
var objs = [];
function getAll() {
    return objs;
}
function get() {
    assert_sidecar_1.assert.t(objs.length > 0, 'no starmap created');
    assert_sidecar_1.assert.t(objs.length === 1, 'more than one starmap created');
    return objs[0];
}
exports.get = get;
function create() {
    var id = common_1.createId();
    var ll = voyageLayers_sidecar_1.voyageLayers.getLayers().starmapTop;
    var imageCurrentLocation = spritesUtil_sidecar_1.spritesUtil.createImage(ll, sprites_sidecar_1.sprites.voyStarmapAt[0]);
    var imageTargetLocation = spritesUtil_sidecar_1.spritesUtil.createImage(ll, sprites_sidecar_1.sprites.voyStarmapTarget[0]);
    var imageCursor = spritesUtil_sidecar_1.spritesUtil.createImage(ll, sprites_sidecar_1.sprites.voyStarmapCursor[0]);
    var obj = {
        id: id,
        idLoaded: 0,
        seed: 0,
        eType: 'starmap',
        isDead: false,
        imageCurrentLocation: imageCurrentLocation,
        imageCursor: imageCursor,
        imageTargetLocation: imageTargetLocation,
        hoveredTile: null,
        tiles: [],
        width: 40,
        height: 20,
        ox: 100,
        oy: 200,
        currentI: 0,
        currentJ: 0,
        targetI: 0,
        targetJ: 0,
        tileSize: 8 * 4,
    };
    objs.push(obj);
    for (var j = 0; j < obj.height; j++) {
        for (var i = 0; i < obj.width; i++) {
            var t = voyageStarmapTiles_sidecar_1.voyageStarmapTiles.create(i, j, i * obj.tileSize + obj.ox, j * obj.tileSize + obj.oy);
            obj.tiles.push(t);
        }
    }
    return obj;
}
exports.create = create;
function killAll() {
    objs.forEach(function (c) {
        kill(c);
    });
}
exports.killAll = killAll;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function setVisible(isVisible) {
    var ll = voyageLayers_sidecar_1.voyageLayers.getLayers();
    ll.starmapBack.visible = isVisible;
    ll.starmapLocation.visible = isVisible;
    ll.starmapTop.visible = isVisible;
}
exports.setVisible = setVisible;
function updateAll() {
    objs.forEach(function (c) {
        update(c);
    });
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        imports_1.l.forEach(c.tiles, function (d) {
            voyageStarmapTiles_sidecar_1.voyageStarmapTiles.kill(d);
        });
    });
}
exports.updateAll = updateAll;
function update(obj) {
    var ll = voyageLayers_sidecar_1.voyageLayers.getLayers();
    obj.hoveredTile = null;
    if (!ll.starmapBack.visible) {
        return;
    }
    var isInHyperspace = voyageGameMode_game_hyperspace_sidecar_1.voyageGameMode_game_hyperspace.getIsInHyperspace();
    var t = getTileAtMouse(obj);
    if (t) {
        obj.hoveredTile = t;
        if (clickEater_sidecar_1.clickEater.isLeftFirstDownRegardless()) {
            // if (t.isRevealed && !t.isVisited) {
            //   // starmapGenerator.travelTo(obj, t.i, t.j, false)
            //   // tileMapEditor.setMode('test')
            // }
            if (!isInHyperspace) {
                if (obj.targetI === t.i && obj.targetJ === t.j) {
                    tryJumpToTarget();
                }
                if (t.isRevealed) {
                    obj.targetI = t.i;
                    obj.targetJ = t.j;
                }
            }
        }
        clickEater_sidecar_1.clickEater.tempEat();
        setImageTo(obj, obj.imageCursor, t.i, t.j);
        obj.imageCursor.visible = true;
    }
    else {
        obj.imageCursor.visible = false;
    }
    setImageTo(obj, obj.imageCurrentLocation, obj.currentI, obj.currentJ);
    setImageTo(obj, obj.imageTargetLocation, obj.targetI, obj.targetJ);
    if (isInHyperspace) {
        spritesUtil_sidecar_1.spritesUtil.setPackedFrame(obj.imageCurrentLocation, sprites_sidecar_1.sprites.voyStarmapInTransitTo[0]);
    }
    else {
        spritesUtil_sidecar_1.spritesUtil.setPackedFrame(obj.imageCurrentLocation, sprites_sidecar_1.sprites.voyStarmapAt[0]);
    }
    obj.imageTargetLocation.visible =
        obj.targetI !== obj.currentI || obj.targetJ !== obj.currentJ;
    clickEater_sidecar_1.clickEater.tempEatCursor();
}
function tryJumpToTarget() {
    var obj = get();
    if (obj.currentI !== obj.targetI || obj.currentJ !== obj.targetJ) {
        // Travel here
        var status_1 = voyageGameStatus_sidecar_1.voyageGameStatus.get();
        if (status_1.jumpCharge >= 98 &&
            !voyageGameMode_game_hyperspace_sidecar_1.voyageGameMode_game_hyperspace.getIsInHyperspace()) {
            voyageStarmapGenerator_sidecar_1.voyageStarmapGenerator.requestTravelTo(obj.targetI, obj.targetJ, false);
        }
        else {
            voyageSounds_sidecar_1.voyageSounds.playFailure();
        }
    }
    else {
        voyageSounds_sidecar_1.voyageSounds.playFailure();
    }
}
exports.tryJumpToTarget = tryJumpToTarget;
function setImageTo(obj, image, i, j) {
    image.x = i * obj.tileSize + obj.ox;
    image.y = j * obj.tileSize + obj.oy;
}
exports.setImageTo = setImageTo;
function getTile(map, i, j) {
    if (!inRange(map, i, j)) {
        return null;
    }
    return map.tiles[j * map.width + i];
}
exports.getTile = getTile;
function getTileAtMouse(map) {
    var sc = common_sidecar_1.common.getPhaserScene();
    var mx = sc.input.mousePointer.x;
    var my = sc.input.mousePointer.y;
    // let x = mx / stevieCam.getZoom() - map.ox + cam.camera.scrollX
    // let y = my / stevieCam.getZoom() - map.oy + cam.camera.scrollY
    var ll = voyageLayers_sidecar_1.voyageLayers.getLayers();
    // let x = mx - map.ox - ll.starmapBack.x
    // let y = my - map.oy - ll.starmapBack.y
    var x = mx / voyageCameraStarmap_sidecar_1.voyageCameraStarmap.get().zoom - map.ox - ll.starmapBack.x;
    var y = my / voyageCameraStarmap_sidecar_1.voyageCameraStarmap.get().zoom - map.oy - ll.starmapBack.y;
    var tx = Math.floor(x / map.tileSize + 0.5);
    var ty = Math.floor(y / map.tileSize + 0.5);
    return getTile(map, tx, ty);
}
exports.getTileAtMouse = getTileAtMouse;
function getTileUnsafe(map, i, j) {
    if (!inRange(map, i, j)) {
        throw new Error("out of range! " + i + " {$ty}");
    }
    return map.tiles[j * map.width + i];
}
exports.getTileUnsafe = getTileUnsafe;
function inRange(map, i, j) {
    if (i >= 0 && i < map.width) {
        if (j >= 0 && j < map.height) {
            return true;
        }
    }
    return false;
}
exports.inRange = inRange;
